
<template>
  <b-modal ref="modal" hide-footer title="Whats New?">

    <div v-if="maintenance">

      <div v-if="maintenance.one80features">
        <h5>One80 Features</h5>
        <pre>{{maintenance.one80features}}</pre>
      </div>

      <div v-if="maintenance.one80bugFixes">
        <h5>One80 Bug Fixes</h5>
        <pre>{{maintenance.one80bugFixes}}</pre>
      </div>

      <div v-if="maintenance.randDFeatures">
        <h5>RandD Features</h5>
        <pre>{{maintenance.randDFeatures}}</pre>
      </div>

      <div v-if="maintenance.randDBugFixes">
        <h5>RandD Bug Fixes</h5>
        <pre>{{maintenance.randDBugFixes}}</pre>
      </div>

      <div v-if="maintenance.globeFeatures">
        <h5>Globe Features</h5>
        <pre>{{maintenance.globeFeatures}}</pre>
      </div>

      <div v-if="maintenance.globeBugFixes">
        <h5>Globe Bug Fixes</h5>
        <pre>{{maintenance.globeBugFixes}}</pre>
      </div>

      <div v-if="maintenance.nbsfeatures">
        <h5>NBS Features</h5>
        <pre>{{maintenance.nbsfeatures}}</pre>
      </div>

      <div v-if="maintenance.nbsbugFixes">
        <h5>NBS Bug Fixes</h5>
        <pre>{{maintenance.nbsbugFixes}}</pre>
      </div>

      <div v-if="maintenance.bmefeatures">
        <h5>BME Features</h5>
        <pre>{{maintenance.bmefeatures}}</pre>
      </div>

      <div v-if="maintenance.bmebugFixes">
        <h5>BME Bug Fixes</h5>
        <pre>{{maintenance.bmebugFixes}}</pre>
      </div>

      <div v-if="maintenance.dataRollout">
        <h5>Data Rollout</h5>
        <pre>{{maintenance.dataRollout}}</pre>
      </div>
    </div>

    <div class="text text-right">
      <b-button class="mt-3" variant="success" @click="hideModal">
        <font-awesome-icon icon="check" /> Okay
      </b-button>
    </div>
  </b-modal>
</template>

<script>

export default {
  props: {
    maintenance: Object,
  },

  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
pre {
  margin: 0 0 5px 0;
}

h5 {
  margin: 0;
}
</style>
